import React from "react";
import { TbCalendarEvent, TbFileCertificate, TbPencil, TbFileDescription } from "react-icons/tb";
import {
  Box,
  Col,
  Dialog,
  FabButton,
  Icon,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { formatToDDMMYYYY, removeUnderScrSpCharSpaceBet, sliceText } from "../../../utils/common";
import {safeString } from "../../../utils/logger";
import { Card, CardHeading, OrganizationBx, OrganizationEmDetails } from "../../style";
import { getTodayDate } from "./graturity-utils";

const StatutoryGratuityActView = ({
  handleOpenStatutoryPtaxModal,
  handleCloseStatutoryPtaxModal,
  setOpenPtaxModal,
  gratuityInfo,
  handleSubmit,
  errors,
  handleChange,
  selectValue,
  isGratuityEnabled,
  gratuityInfoData,
  statutoryGratuityCreateUpdateloading,
  handleToggleGratuity,
}) => {

  return (
    <>
      <Card>
        <CardHeading Divider>
            <Box>
              Gratuity ACT Details
            </Box>
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={handleOpenStatutoryPtaxModal}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        {gratuityInfoData?.gratuity_act_no ?
        <OrganizationEmDetails Gap>
          <OrganizationBx>
            <Icon size={"lg"}>
            <TbFileDescription /> {/* Suitable for Act Number */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Gratuity Act No
              </Typography>
              <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                {gratuityInfoData?.gratuity_act_no || "-"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx autoWidth>
            <Icon size={"lg"}>
              <TbFileCertificate /> {/* Suitable for Gratuity Type */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Gratuity Type
              </Typography>
              <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                {gratuityInfoData?.gratuity_type === 1
                  ? "Gratuity Run By Under Labour ACT"
                  : "Gratuity Run By Any Insurance Company"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx autoWidth>
            <Icon size={"lg"}>
              <TbCalendarEvent/> {/* Suitable for Coverage Date */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Gratuity ACT Coverage Date
              </Typography>
              <Typography variant="body2"
                        mb={"0"}
                        color="dark"
                        colorVariant="light"
                        textCase="capitalize">
                {formatToDDMMYYYY(new Date(gratuityInfoData?.coverage_date)) || "-"}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>:
          <>
            <Typography color="primary">
              Gratuity Act is Disabled
            </Typography>
          </>
        }
      </Card>


      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Gratuity ACT"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenPtaxModal}
        onClose={handleCloseStatutoryPtaxModal}
        onSubmit={handleSubmit}
        separator
        loading={statutoryGratuityCreateUpdateloading}
        footer={
          <>
          <Box mr="auto">
            <Switchbox
              label={isGratuityEnabled ? 'Disable Gratuity ACT' : 'Enable Gratuity ACT'}
              color="Primary"
              size="md"
              checked={isGratuityEnabled}
              onChange={handleToggleGratuity}
            />
          </Box>
          </>
        }
      >

        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              name="gratuity_act_no"
              label="Gratuity Act No"
              placeholder="Type Here..."
              type="tel"
              required={true}
              value={gratuityInfo.gratuity_act_no}
              valueSinc={!!gratuityInfo.gratuity_act_no}
              // valueSinc
              onChange={(e) => handleChange(e.target.value, "gratuity_act_no", {
                formateFn: (val) => {
                  return sliceText(removeUnderScrSpCharSpaceBet(safeString(val)), 150)
                }
              })}
              error={errors.gratuity_act_no}
              helperText={errors.gratuity_act_no}
              disabled={isGratuityEnabled ? false : true}
            />
          </Col>
          <Col sm={6}>
            <SelectField
              fullWidth
              label="Gratuity Type"
              name="gratuity_type"
              // options={[
              //     { id: "Gratuity", name: "Gratuity Run By Under Labour ACT." },
              //     { id: "10%", name: "Gratuity Run By Any Insurance Company" },
              // ]}
              options={[
                { id: 1, name: "Gratuity Run By Under Labour ACT." },
                { id: 2, name: "Gratuity Run By Any Insurance Company" },
              ]}
              placeholder="Select Here..."
              required={true}
              value={
                selectValue
              }
              defaultValue={gratuityInfo.gratuity_type}
              onChange={(val) => handleChange(val, 'gratuity_type')}
              error={errors.gratuity_type}
              helperText={errors.gratuity_type}
              disabled={!isGratuityEnabled}
            />

          </Col>

          <Col sm={6}>
            <InputField
              type="date"
              fullWidth
              name="coverage_date"
              label="Gratuity ACT Coverage Date"
              placeholder="Type Here..."
              valueSinc
              required={true}
              value={gratuityInfo.coverage_date}
              onChange={(e) => handleChange(e.target.value, "coverage_date")}
              error={errors.coverage_date}
              helperText={errors.coverage_date}
              max={getTodayDate()}
              disabled={isGratuityEnabled ? false : true}
              readonly={true}
              onKeyDown={(e) => { e.preventDefault() }}
            />
          </Col>
          
        </Row>

      </Dialog>
      {/* Statutory-EPF-Modal */}
    </>
  );
};

export default StatutoryGratuityActView;
